import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import { DesktopNavBarStyle as useStyles, DesktopMenuLogo } from '../../../styles/DesktopNavBarStyle';
import { CURRENT_APP_THEME } from '../../../styles/stylesSelector';
import { useHistory } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { ReactComponent as InfoIcon } from '../../../resources/images/info.svg';
import { ReactComponent as ChervonRight } from '../../../resources/images/chervon-right.svg';
import { PATH_HOME } from '../../../containers/RoutePaths';

function PageLink({ link, showAlertModal, children }) {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();

    return (
        <Link
            to={'#'}
            className={clsx(classes.navLink, {
                [classes.activeNavLink]: location.pathname.includes(link),
            })}
            onClick={() => {
                if (showAlertModal) {
                    showAlertModal(link);
                } else {
                    history.push(link);
                }
            }}
        >
            {children}
        </Link>
    );
}

export default function DesktopNavBar({ linkObj, isErrorPageHeader, showAlertModal }) {
    const classes = useStyles();
    const history = useHistory();

    const mappedLinkObj = linkObj.map((item, indx) => {
        return (
            <PageLink key={indx} link={item.link} showAlertModal={showAlertModal}>
                {item.text}
            </PageLink>
        );
    });

    return (
        <div>
            <AppBar
                position={isErrorPageHeader ? 'absolute' : 'static'}
                classes={{
                    root: classes.appBarRoot,
                }}
                className={classes.root}
            >
                <div className={classes.toolBar}>
                    <Link
                        to={'#'}
                        onClick={() => {
                            if (showAlertModal) {
                                showAlertModal(PATH_HOME);
                            } else {
                                history.push(PATH_HOME);
                            }
                        }}
                    >
                        <DesktopMenuLogo aria-labelledby={`${CURRENT_APP_THEME} logo`} className={classes.logoImage} />
                    </Link>
                    <div className={classes.desktopLinks}>{mappedLinkObj}</div>
                </div>
            </AppBar>
        </div>
    );
}

export const DesktopChatNavBar = ({ infoClickHandler, setChatBarOpen }) => {
    const classes = useStyles();
    return (
        <AppBar className={classes.chatBarOpen}>
            <div className={classes.chatBarOpenContent}>
                <InfoIcon title={'info icon'} className={classes.infoIcon} onClick={() => infoClickHandler()} />
                <Typography variant="h4" align="center" className={classes.chatBarOpenText}>
                    CHAT
                </Typography>
                <ChervonRight title={'close desktop chat'} className={classes.closeChatArrow} onClick={() => setChatBarOpen(false)} />
            </div>
        </AppBar>
    );
};
